import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Voucher() {
    const [suppliers, setSuppliers] = useState([]);
    const [voucher, setVoucher] = useState({ supplier_id: '', amount: 0, date: new Date().toISOString().split('T')[0], note: '' });

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const fetchSuppliers = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/suppliers`);
            setSuppliers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleVoucher = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/vouchers`, voucher);
            alert('Voucher Recorded');
            setVoucher({ supplier_id: '', amount: 0, date: new Date().toISOString().split('T')[0], note: '' });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Payment Voucher</h2>
                <form onSubmit={handleVoucher} className="card p-4">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">Supplier</label>
                            <select className="form-select" value={voucher.supplier_id} onChange={e => setVoucher({...voucher, supplier_id: e.target.value})} required>
                                <option value="">Select Supplier</option>
                                {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Amount</label>
                            <input type="number" className="form-control" value={voucher.amount} onChange={e => setVoucher({...voucher, amount: parseFloat(e.target.value)})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Date</label>
                            <input type="date" className="form-control" value={voucher.date} onChange={e => setVoucher({...voucher, date: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-12">
                            <label className="form-label">Note</label>
                            <textarea className="form-control" value={voucher.note} onChange={e => setVoucher({...voucher, note: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-12 mt-3 d-grid d-md-block">
                            <button type="submit" className="btn btn-warning btn-lg">Save Voucher</button>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
}

export default Voucher;
